import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";

// --- THIS IS THE CORRECTED LINE ---
// It now points one level up to the 'src' directory.
import { db } from "../firebase"; 

import { collection, onSnapshot, query, where } from "firebase/firestore";
import { FaUsers, FaBoxOpen, FaShoppingCart } from "react-icons/fa";

// Import the stylesheet
import './Dashboard.css';

const Dashboard = () => {
  const { user } = useOutletContext() || {};

  // State for real-time data and loading status
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [loading, setLoading] = useState(true);

  // useEffect to fetch real-time data from Firestore
  useEffect(() => {
    // Listener for Total Grocery Customers
    const customerQuery = query(collection(db, 'customers'), where('app_type', '==', 'grocery'));
    const unsubscribeCustomers = onSnapshot(customerQuery, (snapshot) => {
      setTotalCustomers(snapshot.size);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching customers:", error);
      setLoading(false);
    });

    // Listener for Total Products
    const productsRef = collection(db, 'groceryProducts');
    const unsubscribeProducts = onSnapshot(productsRef, (snapshot) => {
      setTotalProducts(snapshot.size);
    }, (error) => {
      console.error("Error fetching products:", error);
    });

    // Listener for Total Orders
    const ordersRef = collection(db, 'grocery orders');
    const unsubscribeOrders = onSnapshot(ordersRef, (snapshot) => {
      setTotalOrders(snapshot.size);
    }, (error) => {
      console.error("Error fetching orders:", error);
    });

    // Cleanup function to unsubscribe
    return () => {
      unsubscribeCustomers();
      unsubscribeProducts();
      unsubscribeOrders();
    };
  }, []);

  if (loading) {
    return <div className="loading-container">Loading Dashboard Data...</div>;
  }

  // Stat cards data with real-time values
  const statCards = [
    { label: 'Total Customers (Grocery)', value: totalCustomers, icon: <FaUsers />, className: 'customers' },
    { label: 'Total Products', value: totalProducts, icon: <FaBoxOpen />, className: 'products' },
    { label: 'Total Orders', value: totalOrders, icon: <FaShoppingCart />, className: 'orders' },
  ];

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1 className="dashboard-title">
          <span>Welcome </span>
          {user?.username || 'User'} 👋
        </h1>
      </header>

      <main>
        <section className="stats-grid">
          {statCards.map((card) => (
            <div key={card.label} className="stat-card">
              <div className={`stat-card-icon ${card.className}`}>
                {card.icon}
              </div>
              <div className="stat-card-info">
                <div className="label">{card.label}</div>
                <div className="value">{card.value}</div>
              </div>
            </div>
          ))}
        </section>

        <section className="sales-chart-container">
          <h2 className="sales-chart-title">📊 Sales Last 30 Days</h2>
          <div className="chart-placeholder">
            (Chart Placeholder)
          </div>
        </section>
      </main>
    </div>
  );
};

export default Dashboard;